import { render, staticRenderFns } from "./05-22-beijing-invitation.vue?vue&type=template&id=015aad33&scoped=true&"
import script from "./05-22-beijing-invitation.vue?vue&type=script&lang=js&"
export * from "./05-22-beijing-invitation.vue?vue&type=script&lang=js&"
import style0 from "./05-22-beijing-invitation.vue?vue&type=style&index=0&id=015aad33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015aad33",
  null
  
)

export default component.exports